import { FaWhatsapp } from "react-icons/fa"
import Button from "../common/Button"

export default function CTASection() {
  const whatsappNumber = "21600000000"
  const message =
    "Bonjour, je souhaite obtenir plus d'informations sur vos produits textiles."

  return (
    <section className="py-16 lg:py-24">
      <div className="container mx-auto px-4 lg:px-8">

        <div
          className="
            bg-gray-900
            rounded-3xl
            px-6
            py-12
            md:px-12
            lg:px-16
            lg:py-16
            text-center
            text-white
          "
        >
          <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-blue-400">
            Contact Rapide
          </span>

          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
            Besoin d'informations sur nos produits ?
          </h2>

          <p className="mt-6 max-w-3xl mx-auto text-gray-300 text-lg leading-relaxed">
            Notre équipe est à votre disposition pour répondre à vos
            questions, vous conseiller et vous accompagner dans vos
            commandes de fournitures textiles et accessoires.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">

            <Button
              href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
                message
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              size="lg"
              className="bg-green-500 hover:bg-green-600 text-white"
            >
              <FaWhatsapp size={22} />

              WhatsApp
            </Button>

            <Button
              to="/contact"
              variant="white"
              size="lg"
            >
              Nous Contacter
            </Button>

          </div>
        </div>

      </div>
    </section>
  )
}